/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Icon } from "antd-mobile";
import Theme from "../../utils/Theme";
import Colors from "../../utils/Color";

const StyledContainer = styled.div`
  width: 5.3em;
  position: relative;
  margin-left: 13px;
  display: flex;
  flex-direction: column;
  color: ${props => (props.selected ? Theme.PrimaryColor : "grey")};
  justify-content: center;
  align-items: center;
  font-size: ${props => (props.fontSize !== null ? props.fontSize : "unset")};
  padding: 1px;
  text-align: center;
`;

const StyledImg = styled.img`
  width: 3.5em;
  height: 3.5em;
  cursor: pointer;
`;

const StyledTitle = styled.span`
  width: 5em;
  height: 1em;
  line-height: 1em;
  margin-top: 10px;
  font-size: 0.85em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: ${props => (props.selected ? "bold" : "normal")};
`;

const StyledIcon = styled(Icon)`
  position: absolute;
  top: 0;
  right: 0;
`;

class CategoryItem extends Component {
  render() {
    const {
      id,
      onItemClicked,
      defaultImageSrc,
      activeImageSrc,
      title,
      fontSize,
      selected
    } = this.props;

    return (
      <StyledContainer
        fontSize={fontSize}
        selected={selected}
        onClick={() => {
          onItemClicked && onItemClicked(id);
        }}
      >
        {selected ? (
          <StyledIcon
            type="check-circle"
            size={"xxs"}
            color={Colors.darkGreenTextColor}
          />
        ) : null}
        <StyledImg
          src={selected ? activeImageSrc : defaultImageSrc}
          alt="Category"
          height="auto"
          width="100%"
        />
        <StyledTitle selected={selected}>{title}</StyledTitle>
      </StyledContainer>
    );
  }
}

CategoryItem.propTypes = {
  id: PropTypes.number.isRequired,
  onItemClicked: PropTypes.func,
  defaultImageSrc: PropTypes.string.isRequired,
  activeImageSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  fontSize: PropTypes.string,
  selected: PropTypes.bool
};

CategoryItem.defaultProps = {
  title: "",
  selected: false,
  defaultImageSrc: "https://via.placeholder.com/150x150/808080",
  activeImageSrc: "https://via.placeholder.com/150x150/F8B43E"
};

export default CategoryItem;



// WEBPACK FOOTER //
// ./src/components/CategoryItem/index.js